<div class="question-table-wrapper">
  @if (dataSource) {
    <table mat-table [dataSource]="dataSource" class="sticky">
      @for (colDef of data.columns; track colDef) {
        <ng-container [matColumnDef]="colDef.key" [sticky]="colDef.isSticky">
          <th
            mat-header-cell
            *matHeaderCellDef
            [innerHTML]="colDef.value | displayMath"
          ></th>
          <ng-container
            [ngTemplateOutlet]="colDef.isSticky ? thTemplate : tdTemplate"
            [ngTemplateOutletContext]="{ colDef: colDef }"
          />
          <ng-template #thTemplate let-colDef="colDef">
            <th
              mat-header-cell
              *matCellDef="let element"
              [innerHTML]="element[colDef.key] | displayMath"
            ></th>
          </ng-template>
          <ng-template #tdTemplate let-colDef="colDef">
            <td
              mat-cell
              *matCellDef="let element"
              [innerHTML]="element[colDef.key] | displayMath"
            ></td>
          </ng-template>
        </ng-container>
      }
      @if (hasHeaderRow) {
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
      }
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  }
</div>
